import {useEffect, useRef} from 'react'
import autoAnimate from '@formkit/auto-animate'
import {useNotifContext} from './notification_context'
import {Notification} from './notification'
import {Layout} from '../layout'
import './styles/index.less'

export const NotificationsContainer = () => {
	const animateRef = useRef()
	const {notifications, centerNotifications, removeNotification, removeCenterNotification} = useNotifContext()

	// reverse notifications so that the last notification is at the top
	const reversedNotifications = notifications.slice().reverse()
	const reversedCenterNotifications = centerNotifications.slice().reverse()

	useEffect(() => {
		animateRef.current && autoAnimate(animateRef.current)
	})

	return (
		<>
			<Layout ref={animateRef} className="notifications-container" direction="vertical" gap={8} horizontal="end">
				{reversedNotifications.map(item => (
					<Notification key={item.id} handleClose={() => removeNotification(item.id)} {...item} />
				))}
			</Layout>
			<Layout className="center-notifications" direction="vertical" gap={8}>
				{reversedCenterNotifications.map(item => (
					<Notification small key={item.id} handleClose={() => removeCenterNotification(item.id)} {...item} />
				))}
			</Layout>
		</>
	)
}
